import {Box, Grid, Paper, Tab, Tabs} from "@mui/material";
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import i18next from "i18next";
import EATabPanel from "../../../components/common/EATabPanel";
import useStyles from "../../../style/js-style/containers/administration/attributes/AttributesStyle";
import DossierModelTab from "./dossierModel/DossierModelTab";
import DocumentManagementTab from "./documentManagement/DocumentManagementTab";
import {useQuery} from "config/Config";
import {useHistory, useParams} from "react-router-dom/cjs/react-router-dom.min";
import {Context} from "states/Store";
import { getAllTypeDoc } from "services/edge/ListService";
import { ERROR } from 'services/common/Constants';
import { PrivilegeEnum, RoleBasedAccessControlContext } from '../../../services/common/RolesUtils';
import { getAdminSettingsBaseRoute } from '../../../components/admin-settings/AdminSettingsUtils';

function Demandes() {
  const {classes} = useStyles();
  const [state, dispatch] = useContext(Context);
  const { hasAnyOfPrivileges } = useContext(RoleBasedAccessControlContext);
  const query = useQuery();
  const configParam = useMemo(() => parseInt(query.get("config")) || hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER_TYPE) ? 0 : 1, [query, hasAnyOfPrivileges]);
  const [selectedTab, setSelectedTab] = useState(configParam);
  const {accountId} = useParams();
  const history = useHistory();

  const getAccountId = useCallback(() => {
    return accountId || state.account?.id;
  }, [accountId, state.account]);

  // Fetch docType translation
  useEffect(() => {
    const getTypeDoc = async (dispatch) => {
      try {
        const response = await getAllTypeDoc(dispatch, null, i18next.language);
        if (response?.content) {
          dispatch({ type: "DOCTYPE_TRADUCTIONS", data: response.content })
        }
      } catch (e) {
        dispatch({
          type: 'ALERT',
          alert: { type: ERROR, msg: e.message
          } });
      }
    }

    if (state.account && i18next.language){
      getTypeDoc(dispatch);
    }
  },[state.account, dispatch]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    history.push(
      `/${getAccountId()}/${getAdminSettingsBaseRoute()}?tab=demandes&config=${newValue}`
    );
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <Grid container justifyContent="space-evenly" spacing={0}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Paper elevation={0} style={{marginTop: "17px"}}>

            {/* Tabs */}
            <Box className={classes.tabsWrapper} sx={{borderBottom: 1, borderColor: 'divider'}}>
              <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                aria-label="demandes tabs"
              >
                < Tab
                  label={i18next.t("adminSettings.demandesDossiers")}
                  {...a11yProps(0)}
                  className={classes.tab}
                  style={{position: "relative", top: "12px"}}
                  disabled={!hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER_TYPE)}
                />
                <Tab
                  label={i18next.t("adminSettings.demandesDocuments")}
                  {...a11yProps(1)}
                  className={classes.tab}
                  style={{position: "relative", top: "12px"}}
                  disabled={!hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_AUTHORIZED_DOCUMENT_TYPE)}
                />
              </Tabs>
            </Box>

            {/* Dossier Model tab */}
            {hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER_TYPE) &&
              <EATabPanel value={selectedTab} index={0} variant={"withoutBackground"}>
                <DossierModelTab/>
              </EATabPanel>
            }

            {/* Documents tab */}
            {hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_AUTHORIZED_DOCUMENT_TYPE) &&
              <EATabPanel value={selectedTab} index={1} variant={"withoutBackground"}>
                <DocumentManagementTab/>
              </EATabPanel>
            }

          </Paper>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Demandes;
